
module.config(function($stateProvider, moment) {

    $stateProvider.state('reports', {
        parent: 'basic',
        url: '/reports',
        templateUrl: 'empty',
        abstract: true,
    });

    $stateProvider.state('program.reports', {
        url: '/reports',
        templateUrl: 'empty',
        abstract: true,
    });

});

